<template>
  <div class="RightNav" :style="{'width': RightNav_Size.width+'px', 'height': RightNav_Size.height +'px',}" :data-type="boxData.type">
    <Btns   :boxData="boxData" :rightNav='rightNav'/>
    <div class="shadowTop"
      :style="{
        'height': TopNav_Size.height+'px',
        'background' : switchBgSprites ? 'rgb(253, 251, 251)' : '#fff',
        'box-shadow' : switchBgSprites ? 'none' : '2px 0px 4px 0px rgba(44, 75, 248, 0.2)',
      }"
    ></div>
    <div class="msgBox" :style="{'width': RightNav_Size.width-23+'px',}">
      <el-tooltip
        effect="dark"
        placement="bottom"
        :open-delay="1000"
        :value="SwitchStyleTip"
      >
        <div slot="content">
          <img src="../../static/img/stylehand.png" style="vertical-align:  -webkit-baseline-middle;;">
          &nbsp;&nbsp;&nbsp;点击这里&nbsp;&nbsp;切换风格
        </div>

        <section
          class="overall-style"
          @click="saveStyle()"
          @mouseout="SwitchStyleTip = false"
        >
          <span class="iconUrl" :style="{'width': `${(RightNav_Size.width > 95 ? 80 : 54)}px`}">
            <img v-if="StyleDataMsg.iconUrl" :src="$handleAssetsUrl(StyleDataMsg.iconUrl)">
          </span>
          <span v-show="RightNav_Size.width > 360" :style="{
            'width': '130px',
            'overflow': 'hidden',
            'font-weight': 'bold',
          }">{{StyleDataMsg.name}}</span>
          <i class="triangle-icon" v-show="RightNav_Size.width > 360"></i>
        </section>
      </el-tooltip>

      <div class="hides-box"
        :style="{
          'background' : switchBgSprites ? 'rgba(248, 248, 248, 0.75)' : '#EFF1F8',
        }"
      >
        <div class="hideRightNav" @click="hideRightBox()">
          <i :class="{'arrow-right': RightNav_Size.width < 300, 'arrow-left': RightNav_Size.width > 300}"></i>
        </div>
      </div>

      <Search :boxData="boxData"/>
      <div class="hr" v-show="RightNavComponents_Size.hHr > 0"></div>
      <Slide :slideState='rightNav'/>
    </div>

    <div class="touchMsgBox" v-if="rightNav && touchMsgBox.touchMsgBox">
      <span style="top: 27px;left: 20px;">
        <img src="../../static/img/touchuphand.png">
      </span>
      <span>
        若您使用的是触屏设备</br>
        用手指向上滑动，可查看</br>
        更多素材分类
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Btns     from './rightnav/btns.vue' // 按钮
import Slide    from './rightnav/slide.vue' // 滑框box
import Search   from './rightnav/search.vue' // 搜索
import Analysis from './mixins/analysis/materialBu'


export default {
  mixins: [ Analysis],
  data() {
    return {
      rightNav : false,   // 控制右侧导航栏
      boxData  : {        // 每次打开的保存数据
        type : 'scenes'
      },
      protection : true, // 保护弹出时不会接连出发
      touchMsgBox : {
        touchMsgBox : true,
      },
      SwitchStyleTip  : false,
      switchBgSprites : false,
    };
  },
  computed: {
    ...mapGetters([
      'TopNav_Size',
      'StyleMsg',
      'StyleDataMsg',
      'RightNav_Size',
      'RightNavComponents_Size',
      'S_GlobalSearch',
      'S_SearchData',
      'SpriteOperation',
      'BgOperation',
      'RightNavReady'
    ])
  },
  watch: {
    SpriteOperation : {
      handler (val) {
        if(val == 'add'){
          this.switchBgSprites = false;
        }else{
          this.switchBgSprites = true;
        }

      }
    },
    BgOperation : {
      handler (val) {
        if(val == 'add'){
          this.switchBgSprites = false;
        }else{
          this.switchBgSprites = true;
        }
      }
    },
    'RightNav_Size.width': {
      handler (val) {
        if (val && val > 95 && !this.RightNavReady) {
          this.$store.commit('set_RightNavReady', true);
        }
      }
    }
  },
  mounted () {
    this.$bus.on('materialPane_vue', (data) => {  // data为空关闭素材弹窗
      if('type' in data && !data.type){  // type = false,主动关闭
        if(this.rightNav){
          this.hideRightBox();
          return;
        }else{
          return;
        }
      }
      if('type' in data && data.type){
        if(this.S_GlobalSearch){  // 判断搜索时的数据是否为空
          if(!this.S_SearchData[data.type].num){
            return;
          }
        }
        this.boxData.type = data.type;
        let rData = data;
        rData.type= this.boxData.type;
        this.$bus.emit("rightSlideBox_vue", rData);
      }
      if(this.rightNav){
        if(!('type' in data) && this.protection){ // data为空时
          this.protection = false;
          this.hideRightBox();
        }
      }else{
        if(this.protection){
          this.protection = false;
          this.hideRightBox();
        }
      }
    });

    this.$bus.on('SwitchStyleTip', (data) => {
      this.SwitchStyleTip = data.data;
    });
  },
  methods: {
    hideRightBox(){
      this.$bus.emit("rightSlideBox_vue", { type: this.boxData.type });
      if(this.rightNav){
        this.$store.commit('save_RightNav', {width: 95});
        this.rightNav = false;
        if(this.S_GlobalSearch){  // 判断搜索时的数据是否为空

          if(!this.S_SearchData[this.boxData.type].num){
            this.$bus.emit('EditorSetOption_vue',{
              data   : true,
              source : 'RightNav',
            });
            this.protection = true;
            return;
          }
        }
      }else{
        let touchMsgBoxData= this.$util.localStorage.get('MESSAGE-APP-data');
        if(touchMsgBoxData && touchMsgBoxData.touchMsgBox){
          this.touchMsgBox.touchMsgBox = false;
        }else{
          if(touchMsgBoxData){
            touchMsgBoxData.touchMsgBox = true;
            this.touchMsgBox.touchMsgBox = true;
          }else{
            touchMsgBoxData = {};
            touchMsgBoxData.touchMsgBox = true;
            this.touchMsgBox.touchMsgBox = true;
          }
          this.$util.localStorage.set('MESSAGE-APP-data', touchMsgBoxData);
          let timeoutid = setTimeout(() => {
            this.touchMsgBox.touchMsgBox = false;
            clearTimeout(timeoutid);
          }, 2000);
        }

        this.$store.commit('save_RightNav', {width: 385});
        this.rightNav = true;
      };
      this.$bus.emit('EditorSetOption_vue',{
        data   : true,
        source : 'RightNav',
      });
      this.protection = true;
    },
    saveStyle(){
      this.materialPushAnalysis({
        type : 'selectStyle'
      });
      this.$bus.emit('stop_listen_BGM');
      this.$bus.emit('Modal_vue', {name : 'style'});
      // 弹出气泡提示
      this.$bus.emit('showTips', {
        text: '选择一个风格后，场景页、背景、道具、形状均会切换至相应的风格。',
        position: {
          top: `${this.TopNav_Size.height + 10}px`,
          right: '110px'
        }
      });
    },
  },
  components: {
    Btns,
    Slide,
    Search,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .RightNav{
    position: absolute;
    left:0;
    top: 0;
    z-index: 20;
    transition: all 0.3s;

    >.msgBox{
      background-color: #fff;
      position: absolute;
      top: 0;
      left: 23px;
      height: 100%;
    }
    >.shadowTop{
      position: absolute;
      top: 0;
      left: 0;
      width: 23px;
      background: #fff;
      box-shadow: 2px 0px 4px 0px rgba(44, 75, 248, 0.2);
    }

		section.overall-style {
			position: absolute;
			top: 0;
			right: 0;
			width: 100%;
			height: 60px;
			display: flex;
			justify-content: space-around;
			align-items: center;
			background-color: #f0f0f8;
      cursor: pointer;

      .iconUrl{
        height: 44px;
        overflow: hidden;
        position: relative;
        border-radius: 8px;

        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: auto;
          height: 44px;
          border-radius: 8px;
          max-width: none;
          background-color: #f0f0f8;
        }
      }
      i.triangle-icon {
        display: inline-block;
        width: 16.3px;
        height: 9.4px;
        background: url('../../static/svg/inverted-triangle.svg') no-repeat center;
      }
      &:hover {
        i.triangle-icon {
          background: url('../../static/svg/inverted-triangle-active.svg') no-repeat center;
        }
      }
		}

    .hides-box {
      position: absolute;
      top: 63px;
      right: -23px;
      width: 23px;
      height: calc(100% - 60px);
      background: #EFF1F8;
    }

    .hideRightNav{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 3px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 20px;
      width: 20px;
      height: 49px;
      background-color: #fff;
      box-shadow: -4px 0px 10px 0px rgba(44, 75, 248, 0.06);
      border-radius: 6px 0px 0px 6px;
      cursor: pointer;
    }
    .arrow-left, .arrow-right {
      display: block;
      width: 9.3px;
      height: 16px;
    }
    .arrow-left {
      background: url('../../static/svg/left-arrow.svg') no-repeat center;
      &:hover {
        background: url('../../static/svg/left-arrow-active.svg') no-repeat center;
      }
    }
    .arrow-right {
      background: url('../../static/svg/right-arrow.svg') no-repeat center;
      &:hover {
        background: url('../../static/svg/right-arrow-active.svg') no-repeat center;
      }
    }

    .touchMsgBox{
      position: absolute;
      left: -260px;
      top: 115px;
      width: 250px;
      height: 100px;
      background: rgba(0,0,0,0.7);
      padding: 10px;
      border-radius: 10px;

      &:before{
        content: '';
        position: absolute;
        top: 30px;
        right: -20px;
        width:0;
        height:0;
        border-width: 8px 8px 8px 12px;
        border-style:solid;
        border-color:transparent transparent transparent rgba(0,0,0,0.7);
      }
      span{
        position: absolute;
        top: 22px;
        left: 95px;
        text-align: left;
        color: #fff;
        font-size: 13px;
      }
    }
  }

  .hr {
    position: absolute;
    top: 130px;
    left: 10px;
    width: 270px;
    height: 2px;
    background-color: #d4d4e7;
  }
</style>



// WEBPACK FOOTER //
// src/components/RightNav.vue